export enum BaseExportType {
  CSV = 'Csv',
  Text = 'Text',
}

export enum GraphCustomExportType {
  Json = 'Json',
  JsonMeter = 'JsonMeter',
  SDX = 'SDX',
  SBS = 'SBS',
  UU = 'UU',
  YW = 'YW',
  STW = 'STW',
  Unspecified = 'Unspecified',
}

export type GraphExportType = BaseExportType | GraphCustomExportType;
